import { render } from "./EditEventRecap.vue?vue&type=template&id=4bbccd09"
import script from "./EditEventRecap.vue?vue&type=script&lang=js"
export * from "./EditEventRecap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__